import {isTranslateMode} from "../services/lang/LanguageService";
import {useUserState} from "../store/user-store";
import {easasAlert} from "../components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {copyToClipBoard} from "../components/dashboard/dataset-info-search/utils";

const TOLGEE_PROJECT_URL = "https://tolgee.apps.energyadvice.lt/projects/2/translations"

function textIsWrappedInDoubleBraces(text: string | null) {
  if(!text) return false

  text = text.trim()
  return text.startsWith("{{") && text.endsWith("}}")
}

function translateKeyClickHandler(e: MouseEvent) {
  if (!e.ctrlKey) return // only trigger on ctrl+click

  // prevent default behavior for click
  e.preventDefault()

  // block click event propagation
  e.stopPropagation()
  e.stopImmediatePropagation()

  // if element has only one child, and it is a text node
  const tgt = e.target as HTMLElement
  if (tgt.childNodes.length === 1 && tgt.childNodes[0].nodeType === Node.TEXT_NODE) {

    // highlight clicked element
    tgt.style.color = "red"
    tgt.style.fontWeight = "bold"
    setTimeout(() => {
      tgt.style.color = ""
      tgt.style.fontWeight = ""
    }, 1000)

    // Validate if text is translate key
    const text = tgt.textContent
    if(!textIsWrappedInDoubleBraces(text)) {
      return
    }

    const key = text!.replace(/{{/g, "").replace(/}}/g, "")
    const url = `${TOLGEE_PROJECT_URL}?search=${key}`

    // copy key to clipboard and open Tolgee
    // noinspection JSIgnoredPromiseFromCall
    copyToClipBoard(key)
    easasAlert("Copied translate key to clipboard. Opening Tolgee... ")
    setTimeout(() => {
        window.open(url, "tolgee-tab")
    }, 500)
  }
}

useUserState.subscribe((state) => {
  if (state.isCurrentUserLoaded) {
    if(isTranslateMode()) {
      document.addEventListener("click", translateKeyClickHandler)
    }
  }

  return () => {
      document.removeEventListener("click", translateKeyClickHandler)
  }
});
